import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { IDSAuthService } from './idsauth.service';
@Injectable({
  providedIn: 'root',
})
export class RestAPIService {

    constructor(private http: HttpClient, private router: Router, private idsAuthService: IDSAuthService) {}

    private getHttpOptions(withAuth: boolean = true): { headers: HttpHeaders } {
        const headers: any = { 'Content-Type': 'application/json' };

        if (withAuth) {
          const ids_loggedin_token  = localStorage.getItem('ids_loggedin_token ');
          if (!ids_loggedin_token ) {
            this.router.navigate(['/login']);
            return { headers: new HttpHeaders(headers) };
          }
          // Parse the current user token (assuming it's stored as a JSON string)
          let token = ids_loggedin_token ;
          try {
            const parsedUser = JSON.parse(ids_loggedin_token );
            token = parsedUser.access_token || parsedUser;
          } catch (e) {
            // If it's not JSON, use it as is
            token = ids_loggedin_token ;
          }
          headers['Authorization'] = `Bearer ${token}`;
        }

        return {
          headers: new HttpHeaders(headers)
        };
    }
    

    get<T>(url: any, withAuth: boolean = true): Observable<T> {
        return this.http.get<T>(url, this.getHttpOptions(withAuth)).pipe(retry(1), catchError(this.handleError));
    }
    
    post<T>(url: any, body: any, withAuth: boolean = true): Observable<T> {
        return this.http
            .post<T>(
                url,
                JSON.stringify(body),
                this.getHttpOptions(withAuth)
            ).pipe(retry(1), catchError(this.handleError));
    }

    put<T>(url: any, body: any, withAuth: boolean = true): Observable<T> {
        return this.http
            .put<T>(
                url,
                JSON.stringify(body),
                this.getHttpOptions(withAuth)
            )
            .pipe(retry(1), catchError(this.handleError));
    }

    delete<T>(url: any, body: string, withAuth: boolean = true): Observable<T> {
        return this.http
            .delete<T>(url, this.getHttpOptions(withAuth))
            .pipe(retry(1), catchError(this.handleError));
    }

    // Error handling
  handleError = (error: any) => {
    let errorMessage = '';

    if (error.status === 401) {
      // Unauthorized: redirect to login
      this.idsAuthService.endSigninMainWindow();
      this.router.navigate(['/login']);
      errorMessage = 'Unauthorized access. Redirecting to login...';
    } else if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.error.Message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.error.Message}`;
    }
    return throwError(() => {
      return errorMessage;
    });
  }
}